import styled, { css } from 'styled-components';
import {
    ModalDialog,
    Select,
} from '@zillow/constellation';

import AutoComplete from 'app/shared/components/Autocomplete';

export const StyledModalDialog = styled(ModalDialog)`
    &.ModalDialog--disabled {
        [class^="DialogClose"] {
            display: none;
        }
    }
`;

export const StyledAutoComplete = styled(AutoComplete)`
    ${props => props.theme &&
    props.theme.ns &&
    css`
        .Autocomplete-Result-Item {
            &.active,
            &:hover {
            color: #fff;
            background-color: ${props.theme.ns().colors.blue500};
            }
        }
        z-index: 2;
        ${props.theme.ns().spacing.getSpacingMixin()};

        .Input-container {
            margin-top: ${props.theme.ns().spacing.xs()};
        }
    `
}
`;

export const StyledSelect = styled(Select)`
    ${props => props.theme &&
    props.theme.ns &&
    css`
    color: ${props.theme.ns().colors.gray500};
    `}
`;

export const StyledCheckboxContainer = styled.div`
    display: flex;
    flex-direction: row;
`;
